/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Storage_LabelInputs */



/**
* | output |
* | --- |
* | "Storage Location" |
*
* @param {Iconik_Publish_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_storage_label = /** @type {((inputs?: Iconik_Publish_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplacement de stockage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lagerort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione di archiviazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Место хранения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación de almacenamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("存储位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保管場所")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रखने की जगह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local de armazenamento")
	return /** @type {LocalizedString} */ ("Storage Location")
});